import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeleteDistributor() {
  const [loading, setLoading] = useState(false);

  async function execute(distributorId: string, callback?: any) {
    try {
      setLoading(true);
      const response = await api.delete(
        `v1/backoffice/distributors/${distributorId}`,
        {},
      );

      if (response.status === 204) {
        toast.success(ToastMessages.distributor.success.deleteDistributor);

        if (callback) {
          callback();
        }
      }
    } catch (error: any) {
      const errorData = error.response.data;

      if (!Array.isArray(errorData.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        errorData.message.map((err: string) => toast.error(err));
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
